import { render, staticRenderFns } from "./TimetableWidget.vue?vue&type=template&id=e738cf6a"
import script from "./TimetableWidget.vue?vue&type=script&lang=js"
export * from "./TimetableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports